import type { ApiResponse } from '@mindweb/shared'
import { useAuthStore } from './store/auth'

const BASE_URL = import.meta.env.VITE_API_URL ?? ''

async function request<T>(
  path: string,
  options: RequestInit = {},
): Promise<ApiResponse<T>> {
  const { accessToken, refreshTokens } = useAuthStore.getState()

  const headers = new Headers(options.headers)
  headers.set('Content-Type', 'application/json')

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`)
  }

  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers,
  })

  if (response.status === 401 && accessToken) {
    const refreshed = await refreshTokens()
    if (refreshed) {
      headers.set('Authorization', `Bearer ${useAuthStore.getState().accessToken}`)
      const retryResponse = await fetch(`${BASE_URL}${path}`, {
        ...options,
        headers,
      })
      return retryResponse.json() as Promise<ApiResponse<T>>
    }
  }

  return response.json() as Promise<ApiResponse<T>>
}

export const api = {
  get: <T>(path: string) => request<T>(path),

  post: <T>(path: string, body?: unknown) =>
    request<T>(path, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined,
    }),

  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, {
      method: 'PATCH',
      body: body ? JSON.stringify(body) : undefined,
    }),

  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
}
